export default "__VITE_ASSET__DlqFR0m3__"